import { BlockedRangeMs } from './court-grid.model';

/**
 * Sort-once, early-exit overlap check — mirrors the backend's
 * precomputeBlockedRanges/hasOverlapWithBlockedRanges pattern in
 * booking-backend/src/courts/courts.service.ts. `ranges` must be sorted
 * ascending by startMs.
 */
export function hasOverlapWithBlockedRanges(
  startMs: number,
  endMs: number,
  ranges: BlockedRangeMs[],
): boolean {
  for (const range of ranges) {
    // Ranges are sorted ascending — once a range starts at/after our end,
    // no later range can overlap either.
    if (range.startMs >= endMs) break;
    if (range.endMs > startMs) return true;
  }
  return false;
}

/**
 * Nearest blocked range that ends at or before `atMs` (i.e. the range
 * immediately above a candidate position) — used to clamp a top-handle
 * resize or a move-drag's upper bound.
 */
export function nearestRangeBefore(
  atMs: number,
  ranges: BlockedRangeMs[],
): BlockedRangeMs | undefined {
  let result: BlockedRangeMs | undefined;
  for (const range of ranges) {
    if (range.endMs > atMs) break;
    result = range;
  }
  return result;
}

/**
 * Nearest blocked range that starts at or after `atMs` (i.e. the range
 * immediately below a candidate position) — used to clamp a bottom-handle
 * resize or a move-drag's lower bound.
 */
export function nearestRangeAfter(
  atMs: number,
  ranges: BlockedRangeMs[],
): BlockedRangeMs | undefined {
  for (const range of ranges) {
    if (range.startMs >= atMs) return range;
  }
  return undefined;
}
